module.exports = [{
      plugin: require('/tmp/3e005e78/node_modules/gatsby-plugin-mdx/gatsby-browser.js'),
      options: {"plugins":[],"defaultLayouts":{"default":"/tmp/3e005e78/src/components/layout.js"}},
    },{
      plugin: require('/tmp/3e005e78/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
